import React from "react";
import { Grid } from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import InputField from "@commonComponents/formComponents/CustomInputField";
import { selectGoodsLocationType } from "../../selectors";
import { useSelector } from "react-redux";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";

export const GoodLocationForm = React.memo(({ translate, dataSource: { postcode, houseNumber, freeText, country, type }, houseNumberStyle = {}, countryList, onChange, onBlur, onSelect }) => {
  const goodsLocationTypeList = useSelector(selectGoodsLocationType)
  const { version, isImportShipment, serviceType } = useCurrentShipmentType()
  const isDMS = version === 'DMS'
  return (
    <Grid.Row>
      <Grid.Column>
        <InputField
          id="postalCode"
          name="postcode"
          type="text"
          value={postcode}
          label={translate("POSTAL_CODE", { ns: ["default", "header"] })}
          onChange={onChange}
          onBlur={onBlur}
        />
      </Grid.Column>
      <Grid.Column style={houseNumberStyle}>
        <InputField
          id="houseNo"
          name="houseNumber"
          type="text"
          label={translate("HOUSE_NO", { ns: ["default", "header"] })}
          onChange={onChange}
          onBlur={onBlur}
          value={houseNumber}
        />
      </Grid.Column>
      {!isDMS && (
        <Grid.Column>
          <InputField
            id="freeText"
            name="freeText"
            type="text"
            value={freeText}
            label="Free Text"
            onChange={onChange}
            onBlur={onBlur}
          />

        </Grid.Column>
      )}
      <Grid.Column>
        <DropDown
          id="goodLocationtype"
          name="country"
          clearable
          data={countryList}
          label={translate("COUNTRY", { ns: ["default", "parties"] })}
          onChange={onSelect}
          value={country}
          text={country}
        />
      </Grid.Column>
      <Grid.Column>
        <DropDown
          id="goodLocationtype"
          data={goodsLocationTypeList}
          name="type"
          label="type"
          clearable
          onChange={onSelect}
          value={type}
          text={type}
        />
      </Grid.Column>
    </Grid.Row>
  )
})

